import React, { useEffect } from "react";
import DataTable from "./DataTable";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getAllUserActivity } from "../features/admin/adminSlice";

function Activities() {
  const dispatch = useDispatch();

  const { activity: activities = [] } = useSelector(
    (state) => state.admin
  );

  useEffect(() => {
    dispatch(getAllUserActivity());
  }, [dispatch]);

  const columns = [
    { label: "App", key: "assistantId.name" },
    { label: "Account Name", key: "userId.name" },
    { label: "Account Email", key: "userId.email" },
    { label: "Connect/Disconnect", key: "isInstalled" },
    { label: "Created At", key: "createdAt" },
  ];

  const rowRenderer = (a) => (
    <tr key={a.uuid}>
      <td className="align-middle ps-3">
        {a?.assistantId?.name || "-"}
      </td>

      <td className="align-middle ps-3">
        {a?.userId?.name || "-"}
      </td>

      <td className="align-middle ps-3">
        {a?.userId?.email || "-"}
      </td>

      <td className="align-middle ps-3">
        <span
          className={`badge ${
            a?.isInstalled ? "bg-success" : "bg-danger"
          }`}
        >
          {a?.isInstalled ? "Connected" : "Disconnected"}
        </span>
      </td>

      <td className="align-middle ps-3">
        {moment.utc(a?.createdAt).format("MMM D, YYYY • h:mm A")}
      </td>
    </tr>
  );

  return (
    <div className="content">
      <div className="row">
        <div className="col-12">
          <DataTable
            title="Activities"
            data={activities}
            columns={columns}
            rowRenderer={rowRenderer}
          />
        </div>
      </div>
    </div>
  );
}

export default Activities;